import { IInventoryPage } from '../../inventory-page.interface';


export const SETTINGS_TOKENS_PAGE: IInventoryPage = {
	'route': '/settings/tokens',
	'title': 'Tokens',
	'uiReference': [
		'Loading token records',
		'Invoices',
		'Tokens',
		'Track token packages, expiration, and usage.',
		'Loading token records...',
		'No token records found',
		'Token packages will appear here after purchase or assignment.',
		'(Grace Period)',
		'package is expired on',
		'No Tokens left',
		'Package is deactivated by System',
		'Assigned by the support',
		'Package free of charge',
		'- Order ID',
		'View Invoice',
		'Send to Mail',
		'Token usage history',
		'Token usage month navigation',
		'Show previous month',
		'Show next month',
		'Loading token usage',
		'Usage period',
		'Loading token usage...'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/setting/setting-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/setting/settings-pages/general/tokens/tokens.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/setting/settings-pages/general/tokens/tokens.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/setting/settings-pages/general/tokens/tokens-usage-chart/tokens-usage-chart.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/setting/settings-pages/general/tokens/tokens-usage-chart/tokens-usage-chart.component.html'
	]
};
